import React, { useState, useEffect } from "react";
import { MenuAside } from "./menuAside/menuAside";
import { Header } from "./header/header";
import { backendService } from "../services/backend.service";
import { useDispatch, useSelector } from "react-redux";
import { setUserSettings } from "../store/actions";
import { BlockScreen } from "./blockScreen/blockScreen";
import { InstallPWA } from "./pwa/installPWA";
import ItemsBalance from "./itemsBalance/itemsBalance";
import useWindowViewport from "../hooks/useWindowsViewport";

export function LayoutFull(props) {
  const dispatch = useDispatch();
  const [activeMenu, setActiveMenu] = useState("");
  const [companyBalance, setCompanyBalance] = useState(null);
  const settings = useSelector((state) => state.userSettings);
  const { windowWidth } = useWindowViewport();
  const [activeBtn, setStateBtn] = useState("");

  const MenuPurchaseBox = () =>
    setActiveMenu(activeMenu === "" ? " is-show" : "");

  const BtnSet = () => setStateBtn(activeBtn === "" ? " visible_menu" : "");

  const MyFun = () => {
    BtnSet();
    MenuPurchaseBox();
  };

  const setCompanyCustom = (companyCustom) => {
    const userPreferences =
      companyCustom.preferences != null
        ? JSON.parse(companyCustom.preferences)
        : null;
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `:root {--primary_color: ${
      userPreferences && userPreferences.PrimaryColor != null
        ? userPreferences.PrimaryColor
        : companyCustom.primaryColor
    };--secondary_color: ${companyCustom.secondaryColor};}`;
    document.getElementsByTagName("head")[0].appendChild(style);
  };

  useEffect(() => {
    if (
      settings.roleName == "Admin_Intermediario" ||
      settings.roleName == "Admin_Empresa"
    )
      getCompanyBalance();
  }, [settings.roleName]);

  const getCompanyBalance = () =>
    backendService
      .getCompanyBalance()
      .then((result) => setCompanyBalance(result));

  useEffect(() => {
    backendService.userSettings().then((result) => {
      dispatch(setUserSettings(result));
      setCompanyCustom(result);
    });
  }, []);

  return (
    <section className="wrapper_main">
      <BlockScreen />
      <MenuAside activeMenu={activeMenu} closeAll={() => MyFun()} />

      <div className="section_main trans">
        <Header
          MyFun={() => MyFun()}
          activeBtn={activeBtn}
          history={props.history}
          companyBalance={companyBalance}
          windowWidth={windowWidth}
        />
        {/* {windowWidth < 768 && companyBalance && (
          <ItemsBalance companyBalance={companyBalance} />
        )} */}
        {props.children}
      </div>
      <InstallPWA />
    </section>
  );
}

export function LayoutOperations(props) {
  const dispatch = useDispatch();
  const [activeMenu, setStateMenu] = useState("");
  const MenuPurchaseBox = () => {
    setStateMenu(activeMenu === "" ? " is-show" : "");
  };

  const [activeBtn, setStateBtn] = useState("");
  const BtnSet = () => {
    setStateBtn(activeBtn === "" ? " visible_menu" : "");
  };

  const MyFun = () => {
    BtnSet();
    MenuPurchaseBox();
  };

  useEffect(() => {
    backendService
      .userSettings()
      .then((result) => dispatch(setUserSettings(result)));
  }, []);

  return (
    <section className="wrapper_main">
      <BlockScreen />
      <MenuAside activeMenu={activeMenu} closeAll={() => MyFun()} />

      <div className="section_main trans">
        <Header
          MyFun={() => MyFun()}
          activeBtn={activeBtn}
          history={props.history}
        />
        {props.children}
      </div>
      <InstallPWA />
    </section>
  );
}

export function LayoutLess(props) {
  return (
    <section>
      <BlockScreen />
      {props.children}
      <InstallPWA />
    </section>
  );
}
